import { createFileRoute, Outlet } from '@tanstack/react-router'
import { OrganizationGuard } from '@/components/organization-guard'
import AppNavigationShell from '@/components/organisms/app-navigation-shell'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <OrganizationGuard>
      <AppNavigationShell>
        <Outlet />
      </AppNavigationShell>
    </OrganizationGuard>
  )
}
